import type { FC } from "react";

import { Box, Stack, Typography } from "@mui/material";
import CustomTextField from "../../../components/CustomTextField";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";

import { useTheme } from "@emotion/react";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";

interface AddCampaignTitleProps {
  isFetching: boolean;
  campaignName: string;
  edit: boolean;
  onEdit: () => void;
  onSave: (newName: string) => void;
}

export const AddCampaignTitle: FC<AddCampaignTitleProps> = ({
  campaignName,
  isFetching,
  edit,
  onEdit,
  onSave,
}) => {
  const theme = useTheme() as any;
  const { t } = useTranslation();

  const [name, setName] = useState<string>(campaignName);

  useEffect(() => {
    if (campaignName) {
      setName(campaignName);
    }
  }, [campaignName]);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        fontSize: 20,
        color: theme.palette.text.primary,
      }}
    >
      <Typography fontSize='inherit'>
        {t("campaign.settings.setCampaign")}:
      </Typography>
      {!isFetching && (
        <Stack direction='row' gap={1} alignItems='center'>
          {edit ? (
            <>
              <CustomTextField
                fullWidth
                label={t("campaign.settings.campaignName") ?? ""}
                value={name}
                onChange={e => setName(e.currentTarget.value)}
              />
              <SaveIcon
                sx={{ cursor: "pointer" }}
                onClick={() => onSave(name)}
              />
            </>
          ) : (
            <>
              <Typography
                fontSize='inherit'
                sx={{
                  fontWeight: "bold",
                  color: theme.palette.main.secondary.u1,
                }}
              >
                {campaignName}
              </Typography>
              <EditIcon sx={{ cursor: "pointer" }} onClick={onEdit} />
            </>
          )}
        </Stack>
      )}
    </Box>
  );
};
